"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useCallback } from "react"

import SortProducts, { SortOptions } from "./sort-products"
import VariantFilters from "./variant-filters"

type VariantOption = {
  id: string
  title: string
  values: string[]
}

type RefinementListProps = {
  sortBy: SortOptions
  search?: boolean
  productOptions?: VariantOption[]
  'data-testid'?: string
}

const RefinementList = ({ 
  sortBy, 
  productOptions,
  'data-testid': dataTestId 
}: RefinementListProps) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams)
      params.set(name, value)

      return params.toString()
    },
    [searchParams]
  )

  const setQueryParams = (name: string, value: string) => {
    const query = createQueryString(name, value)
    router.push(`${pathname}?${query}`)
  }

  return (
    <div className="flex flex-col gap-y-6">
      {/* Sort Options */}
      <SortProducts sortBy={sortBy} setQueryParams={setQueryParams} data-testid={dataTestId} />
      
      {/* Variant Filters */}
      {productOptions && productOptions.length > 0 && (
        <div className="border-t border-beige pt-6">
          <VariantFilters options={productOptions} />
        </div>
      )}
    </div>
  )
}

export default RefinementList
